module.exports = __webpack_public_path__ + "static/media/Incineroar_gaussian2.e1323bfd.png";